import * as React from 'react';
import { DataType } from './data-type';
import { Col, FormControl, Row } from 'react-bootstrap';

interface IProps {
    labelText: string;
    name: string;
    value: any;
    isPassword?: boolean;
    isFormGroup?: boolean;
    boldLabel?: boolean;
    bootstrapColumn1Override?: string;
    bootstrapColumn2Override?: string;
    type?: DataType;
    controlType?: string,
    dimensions?: { label: number, field: number },
    onChange: (name: string, value: any, dataType: DataType) => void
}

const CenterTextInput = (props: IProps) => {
    const handleValueChanged = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let elementVal = e.currentTarget.value;
        let isCurrentValueBlank = elementVal.trim() == '';

        let returnVal: any;

        if (typeof props.type != 'undefined') {
            switch (props.type) {
                case DataType.String:
                    returnVal = elementVal;
                    break;

                case DataType.Integer:
                    returnVal = isCurrentValueBlank ? 0 : parseInt(elementVal);
                    break;

                case DataType.Float:
                    returnVal = isCurrentValueBlank ? 0 : parseFloat(elementVal)
                    break;

                default:
                    returnVal = elementVal;
            }

            props.onChange(props.name, returnVal, props.type);
        } else {
            returnVal = elementVal;
            props.onChange(props.name, returnVal, DataType.String);
        }
    };

    const isFormGroup = typeof (props.isFormGroup) == 'undefined' ? true : props.isFormGroup;

    const dimensions = props.dimensions != null ? props.dimensions : { label: 6, field: 6 };

    if (isFormGroup) {
        return (
            <>
                <Col xs={12} sm={dimensions.label}>
                    <label className='control-label'>{props.labelText}</label>
                </Col>
                <Col xs={12} sm={dimensions.field}>
                    <FormControl
                        type={props.controlType != null ? props.controlType : 'text'}
                        value={props.value}
                        onChange={handleValueChanged}
                    />
                </Col>
            </>
        );
    }

    return (
        <Row>
            <Col xs={12} sm={dimensions.label}>
                <label className='control-label'>{props.labelText}</label>
            </Col>
            <Col xs={12} sm={dimensions.field}>
                <FormControl
                    value={props.value}
                    onChange={handleValueChanged}
                />
            </Col>
        </Row>
    );
}

export default CenterTextInput;